import { formatCount, formatNaira } from '../../../../utils/money';
import { Card, Skeleton } from '../../../ui';

const muted = 'text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor';

const partnerEntries = (today) => [
  { label: 'Gross volume', value: formatNaira(today?.gross_volume) },
  { label: 'Transactions', value: formatCount(today?.txn_count) },
  { label: 'Failed', value: formatCount(today?.failed_count) },
  { label: 'Declined', value: formatCount(today?.declined_count) },
  { label: 'Timed out', value: formatCount(today?.timeout_count) },
  { label: 'Cancelled', value: formatCount(today?.cancelled_count) },
  { label: 'Active PANs', value: formatCount(today?.active_pans) },
];

const TodayPanel = ({ today, loading, entries = partnerEntries(today), className = '' }) => {

  return (
    <Card
      title="Today so far"
      className={`mb-0 h-full ${className}`}
      actions={<span className={`text-sm ${muted}`}>Current UTC day</span>}
      footer={
        <span className={`text-sm ${muted}`}>
          Live counters for today, independent of the period selected above.
        </span>
      }
    >
      <dl className="grid grid-cols-2 gap-x-4 gap-y-5 xl:grid-cols-1">
        {entries.map((entry) => (
          <div key={entry.label}>
            <dt className={`mb-1 text-sm ${muted}`}>{entry.label}</dt>
            <dd className="mb-0 text-f-h5 font-semibold text-theme-headings dark:text-themedark-headings">
              {loading ? <Skeleton w="80%" h="1.4rem" /> : entry.value}
            </dd>
          </div>
        ))}
      </dl>
    </Card>
  );
};

export default TodayPanel;
